import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@tremor/react';
import { useAuth } from '../../hooks/useAuth';

export default function Header() {
  const { user, logout } = useAuth();
  return (
    <header className="flex items-center justify-between border-b border-gray-200 bg-white px-6 py-3">
      <div className="flex items-center gap-6">
        <span className="text-lg font-semibold text-gray-900">Agents</span>
        <nav className="flex items-center gap-4 text-sm text-gray-600">
          <Link to="/" className="hover:text-gray-900">Patients</Link>
          <Link to="/wati" className="hover:text-gray-900">WATI Webhooks</Link>
          <Link to="/taliaz-botv1" className="hover:text-gray-900">TALIAZ-BOTv1</Link>
          <Link to="/whatsapp-ai-bot" className="hover:text-gray-900">WhatsApp AI Bot</Link>
          {user?.role === 'admin' && (
            <Link to="/users" className="hover:text-gray-900">Users</Link>
          )}
        </nav>
      </div>
      <div className="flex items-center gap-4">
        {user && <span className="text-sm text-gray-500">{user.email}</span>}
        <Button variant="secondary" size="xs" onClick={logout}>
          Sign out
        </Button>
      </div>
    </header>
  );
}
